<template>
  <div class="agenda-session-path-tag" :style="colorStyle">
    {{title}}
  </div>
</template>

<script>
export default {
  name: "AgendaSessionPathTag",

  props: {
    pathTag: {
      type: Object,
      required: true,
    }
  },

  computed: {
    colorStyle() {
      return {
        backgroundColor: this.pathTag.hex,
      };
    },

    title() {
      return this.pathTag.value.toUpperCase();
    }
  }
};
</script>

<style scoped lang="scss">
.agenda-session-path-tag {
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  color: #FFFFFF;
}
</style>
